<template>
  <confirm-modal ref="modal" title="Удаление ТМЦ" confirm="Удалить" reset="Отменить" mode="danger" @confirm="confirm">
    <span>
      Позиция <b>№{{ serialNumber }}</b>
      {{ name ? "(" + name + ")" : "" }}
      будет удалена без возможности восстановления.
    </span>
  </confirm-modal>
</template>

<script>
import ConfirmModal from "@/components/modals/confirm-modal";

export default {
  components: { ConfirmModal },
  data() {
    return {
      id: null,
      name: "",
      serialNumber: "",
    };
  },
  computed: {},
  methods: {
    open(item) {
      this.id = item.id;
      this.name = item.name;
      this.serialNumber = item.serialNumber;

      this.$refs.modal.open();
    },
    close() {
      this.$refs.modal.close();
      this.id = null;
      this.name = "";
      this.serialNumber = "";
    },
    confirm() {
      this.$store.dispatch("uniformItems/deleteItem", this.id).then(() => {
        this.close();
        this.$nextTick(() => {
          this.$emit("remove", this.id);
        });
      });
    },
  },
};
</script>
